import NachWrapper from 'features/nach/components/NachWrapper';
import DashboardFilterForm from './components/DashboardFilterForm';

function MandateLinkDashboard() {
  return (
    <NachWrapper
      title="Mandate Link Dashboard"
      className=" col-xs-12 col-sm-12 col-md-11"
      style={{ marginLeft: '5%' }}
    >
      <DashboardFilterForm onSubmit={() => Promise.resolve()} isLoading={false} />
    </NachWrapper>
  );
}

export default MandateLinkDashboard;
